// polyfills
import 'whatwg-fetch';
import 'babel-polyfill';
import 'raf/polyfill';

// Matches polyfill (IE9+)
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector;
}

// Vendor
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';

// Modules
import './modules/lightbox';
import Helpers from './helpers/util';

// Components
import App from './components/App';

// Google analytics loaded check
let checkIfAnalyticsTimeout;
function checkIfAnalyticsLoaded() {
	if (window._gaq && window._gaq._getTracker) {
		// Do tracking with new-style analytics
		Helpers.pubsub.publish('googleAnalyticsLoaded');
		if (checkIfAnalyticsTimeout) {
			clearTimeout(checkIfAnalyticsTimeout);
		}
	} else {
		// Retry
		checkIfAnalyticsTimeout = setTimeout(() => {
			checkIfAnalyticsLoaded();
		}, 200);
	}
}
checkIfAnalyticsLoaded();

// Google maps init
window.mapAPILoaded = () => {
	Helpers.pubsub.publish('googleMapsLoaded');
};
const apiUrl = 'https://maps.googleapis.com/maps/api/js';
const apiKey = 'AIzaSyBH4QjtKA6MmjbGSECTaJ8TDfAzeIEdcdk';
const js = document.createElement('script');
js.type = 'text/javascript';
js.async = true;
js.src = `${apiUrl}?callback=mapAPILoaded&key=${apiKey}&v=3`;
document.body.appendChild(js);

// Render
render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<App />
		</ConnectedRouter>
	</Provider>,
	document.querySelector('.root')
);

Helpers.pubsub.subscribe('onAnimateCb', function(i, isExpanded) {
	if (isExpanded) {
		document.body.classList.add('overlay');
	} else {
		document.body.classList.remove('overlay');
	}
});
